import { render, staticRenderFns } from "./XigCheckHomeMobile.vue?vue&type=template&id=360e18ee&scoped=true"
import script from "./XigCheckHomeMobile.vue?vue&type=script&lang=js"
export * from "./XigCheckHomeMobile.vue?vue&type=script&lang=js"
import style0 from "./XigCheckHomeMobile.vue?vue&type=style&index=0&id=360e18ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360e18ee",
  null
  
)

export default component.exports